import { render, staticRenderFns } from "./ActiveActivitySwitcher.vue?vue&type=template&id=5d2a8b38"
import script from "./ActiveActivitySwitcher.vue?vue&type=script&lang=ts"
export * from "./ActiveActivitySwitcher.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports